import {
  IImageFile,
  IImageFileHierarchical,
  IImageUploadImage,
  IImageUploadImageListResult,
} from '../interfaces/File.js';
import { File } from './File.js';
import { ListResult } from './List.js';

/**
 * Image
 */
class Image extends File implements IImageFile {
  type: string;
  active: boolean;
  width: number;
  height: number;

  /**
   * constructor
   */
  constructor() {
    super();
  }
}

/**
 * ImageHierarchical
 */
class ImageHierarchical extends Image implements IImageFileHierarchical {
  parentId: number;
  children: Array<ImageHierarchical>;

  /**
   * constructor
   */
  constructor() {
    super();
  }
}

/**
 * ImageUploadImage
 */
class ImageUploadImage extends ImageHierarchical implements IImageUploadImage {
  objectType: string;
  objectId: number;
  category: string;
  declare children: Array<ImageUploadImage>;

  /**
   * constructor
   */
  constructor() {
    super();
  }
}

/**
 * ImageUploadImageListResult
 */
class ImageUploadImageListResult extends ListResult implements IImageUploadImageListResult {
  declare items: Array<ImageUploadImage>;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

export { Image, ImageHierarchical, ImageUploadImage, ImageUploadImageListResult };
